import { Injectable } from "@angular/core";
import { CartAddEntrySuccessEvent, CartRemoveEntrySuccessEvent, CartUiEventAddToCart } from "@spartacus/cart/base/root";
import { createFrom, EventService, ProductService } from "@spartacus/core";
import { combineLatest, filter, map, Observable, of, pipe, switchMap, take } from "rxjs";
import { GonvarriCartAddEntrySuccessEvent, GonvarriCartRemoveEntrySuccessEvent } from "./gonvarri-cart.events";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { GonvarriUser } from "src/app/core/models/gonvarri-user.model";
import { GonvarriCartUiEventAddToCart } from "src/app/core/events/GonvarriCartUiEventAddToCart";
import { ofType } from "@ngrx/effects";
import { CART_ADD_SPECIAL_REQUESTS } from "src/app/core/actions/gonvarri-cart-add-entry.action";
import { CartActions } from "@spartacus/cart/base/core";

/**
 * Registers events for the active cart
 */
@Injectable({ providedIn: 'root' })
export class GonvarriCartEventBuilder {

  constructor(
      protected event: EventService,
      protected userAccountFacade: UserAccountFacade,
      protected productService: ProductService,
  ) {
    this.register();
  }

  protected register(): void {
    this.registerAddCartEntryEvents();
    this.registerRemoveCartEntryEvents();
  }

  protected registerAddCartEntryEvents(): void {
    this.event.register(
      GonvarriCartAddEntrySuccessEvent,
      this.buildGonvarriAddEntryEvent(),
    );
    // this.event.register(
    //   GonvarriQuickStockAddEntrySuccessEvent,
    //   this.registerGonvarriQuickStockAddEntry(),
    // );
  }

  protected registerRemoveCartEntryEvents(): void {
    this.event.register(
      GonvarriCartRemoveEntrySuccessEvent,
      this.buildGonvarriRemoveEntryEvent(),
    );
  }

  protected buildGonvarriAddEntryEvent(): Observable<GonvarriCartAddEntrySuccessEvent> {
    return combineLatest([
      this.event.get(CartAddEntrySuccessEvent), // Get the CartAddEntrySuccessEvent to get the product details
      this.userAccountFacade.get().pipe(
        filter(user => !!user),
        take(1)
      ) // Get the user details
    ]).pipe(
      switchMap(([cartEvent, user]) => {
        return of(createFrom(GonvarriCartAddEntrySuccessEvent, {
          // Here we are mapping the default cart event and user details to the custom event matching the same GTM tag used by accelerator. 
          // The only property that is not being mapped is PaquetesAddedToCart which is being defined in GTM via the item counter HTML element
          product_category: cartEvent?.entry?.product?.categories?.[0]?.name?.split("-")[1]?.trimStart() ?? '',
          product_id: cartEvent?.productCode,
          product_name: cartEvent?.entry?.product?.name,
          product_price: cartEvent?.entry?.product?.price?.value,
          user_id: (user as GonvarriUser).orgUnit?.uid ?? '',
          user_email: user?.uid ?? '',
        }));
      }),
    );
  }

  // registerGonvarriQuickStockAddEntry(): Observable<GonvarriQuickStockAddEntrySuccessEvent> {
  //   return combineLatest([
  //     this.event.get(GonvarriCartUiEventAddToCart).pipe(take(1)), // Get the GonvarriCartUiEventAddToCart to get the product details
  //     this.userAccountFacade.get().pipe(
  //       filter(user => !!user),
  //       take(1)
  //     ) // Get the user details
  //   ]).pipe(
  //     switchMap(([cartEvent, user]) => {
  //       // Fetch product details using the productCode from cartEvent
  //       return this.productService.get(cartEvent.product.code!).pipe(
  //         map(product => {
  //           // Create the custom event with product and user details
  //           return createFrom(GonvarriQuickStockAddEntrySuccessEvent, {
  //             product_category: product?.categories?.[0]?.name?.split("-")[1]?.trimStart() ?? '',
  //             product_id: cartEvent.product.code,
  //             product_name: product?.name,
  //             product_price: product?.price?.value,
  //             user_id: (user as GonvarriUser).orgUnit?.uid ?? '',
  //             user_email: user?.uid ?? '',
  //           });
  //         })
  //       );
  //     }),
  //   );
  // }


  protected buildGonvarriRemoveEntryEvent(): Observable<GonvarriCartRemoveEntrySuccessEvent> {
    return this.event.get(CartRemoveEntrySuccessEvent).pipe( // Get the CartRemoveEntrySuccessEvent to then create the custom event
      switchMap(() => this.userAccountFacade.get().pipe( 
        filter(user => !!user),
        take(1),
        map(user => createFrom(GonvarriCartRemoveEntrySuccessEvent, { // Here we are mapping the user details to the custom event matching the same GTM tag used by accelerator.
          user_id: (user as GonvarriUser).orgUnit?.uid ?? '',
          user_email: user?.uid ?? '',
        }))
      ))
    );
  }
}
